import { render, staticRenderFns } from "./article_details.vue?vue&type=template&id=5751bbb2"
import script from "./article_details.vue?vue&type=script&lang=ts"
export * from "./article_details.vue?vue&type=script&lang=ts"
import style0 from "./article_details.vue?vue&type=style&index=0&id=5751bbb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports